var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPrivate)?_c('nav-footer',{attrs:{"tabs":_vm.filterTabs('private')}}):_c('nav-footer',{attrs:{"tabs":_vm.filterTabs('public')}})}
var staticRenderFns = []

export { render, staticRenderFns }